import React, { useState } from 'react';
import { HiOutlineEnvelope } from 'react-icons/hi2';
import { VscGithubAlt } from 'react-icons/vsc';
import { RiLinkedinLine } from 'react-icons/ri';
import { PiInstagramLogoBold } from 'react-icons/pi';

const ContactApp = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [responseMessage, setResponseMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setResponseMessage('Sending...');
    const fd = new FormData(e.target);
    fd.append('access_key', '78a9c8fb-8aa1-44b5-8ac8-7ae63ab09c5a');

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: fd,
      });
      const data = await response.json();
      if (data.success) {
        setResponseMessage('Thank you! I will get back to you soon.');
        e.target.reset();
        setFormData({ name: '', email: '', message: '' });
      } else {
        setResponseMessage(data.message || 'Something went wrong.');
      }
    } catch {
      setResponseMessage('Network error. Please try again.');
    }
    setIsSubmitting(false);
    setTimeout(() => setResponseMessage(''), 8000);
  };

  return (
    <div className="contact-signal-shell">
      <div className="contact-signal-header">
        <div>
          <p className="contact-signal-kicker">Contact</p>
          <h2 className="contact-signal-title">A dispatch console for ideas worth sending.</h2>
          <p className="contact-signal-copy">
            If the work feels aligned, send a message and I’ll treat it like an incoming transmission, clear, direct, and worth answering.
          </p>
        </div>
        <div className="contact-signal-status">
          <span className="contact-signal-status-dot" />
          Open for collaborations
        </div>
      </div>

      <div className="contact-signal-layout">
        <div className="contact-signal-panel">
          <form className="contact-signal-form" onSubmit={onSubmit}>
            <div className="contact-signal-row">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="contact-signal-input"
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="contact-signal-input"
              />
            </div>
            <textarea
              name="message"
              placeholder="What are we building?"
              value={formData.message}
              onChange={handleChange}
              required
              className="contact-signal-textarea"
              rows={5}
            />
            <button
              type="submit"
              className="contact-signal-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Transmission'}
            </button>
          </form>

          {responseMessage && (
            <p className="contact-signal-response">{responseMessage}</p>
          )}
        </div>

        <div className="contact-signal-links">
          <a href="mailto:sr7431@nyu.edu" className="contact-signal-link">
            <span className="contact-signal-link-icon"><HiOutlineEnvelope /></span>
            <span>
              <strong>Email</strong>
              <small>Best for collaboration and roles</small>
            </span>
          </a>
          <a href="https://github.com/exploring-curiosity" target="_blank" rel="noreferrer" className="contact-signal-link">
            <span className="contact-signal-link-icon"><VscGithubAlt /></span>
            <span>
              <strong>GitHub</strong>
              <small>Code, experiments, and prototypes</small>
            </span>
          </a>
          <a href="https://linkedin.com/in/sudharshanramesh" target="_blank" rel="noreferrer" className="contact-signal-link">
            <span className="contact-signal-link-icon"><RiLinkedinLine /></span>
            <span>
              <strong>LinkedIn</strong>
              <small>Career history and professional context</small>
            </span>
          </a>
          <a href="https://instagram.com/_sudhan_r" target="_blank" rel="noreferrer" className="contact-signal-link">
            <span className="contact-signal-link-icon"><PiInstagramLogoBold /></span>
            <span>
              <strong>Instagram</strong>
              <small>Occasional life beyond the lab</small>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactApp;
